import Modal from "./modal.es6";

export default class Ui {
    constructor() {
        this.init();
    }

    init() {
        this.smoothscroll();
        this.gnav();
        this.accordion();
        this.recModal();
        this.modal = new Modal();
    }

    smoothscroll() {
        $('a[href^="#"]')
            .not(".js-noscr")
            .on("click", function (e) {
                e.preventDefault();
                var speed = $(this).attr("data-speed") || 600;
                var href = $(this).attr("href");
                var target = $(href == "#" || href == "" ? "html" : href);
                var position = target.offset().top;
                var offset = parseInt(target.attr("data-offset")) || 0;
                $("body,html").animate({ scrollTop: position + offset }, speed, "swing");
            });

        $(".js-pagetop").on("click", function (e) {
            e.preventDefault();
            var speed = $(this).attr("data-speed") || 600;
            $("body,html").animate({ scrollTop: 0 }, speed, "swing");
        });
    }

    gnav() {
        $(".js-gnav_trigger").on("click", function () {
            $(this).toggleClass("-active");
            $(".js-gnav_wrapper").toggleClass("-active");
        });
    }

    accordion() {
        $(".js-accordion_open").on("click", function () {
            if (window.innerWidth < 768) {
                $(this).toggleClass("-active");
                $(this).next(".js-accordion").slideToggle();
            }
        });
    }

    recModal() {
        $(".js-recmodal__open").on("click", function () {
            $(".recruit_modal").addClass("-active");
        });
        $(".js-recmodal__close").on("click", function () {
            $(".recruit_modal").removeClass("-active");
        });
    }
}
